import { useCallback } from 'react';
import useMemoryStorage, {
  getStoredState,
} from '../../../../../hooks/useMemoryStorage';
import { setupCompanyFields } from './initialState';

export default function useFields(settings) {
  const storeFields = getStoredState('simuladorRe.companyFields');
  const [fields, setFields] = useMemoryStorage(
    'simuladorRe.companyFields',
    setupCompanyFields(settings, storeFields),
    true
  );

  const updateCompanyFieldValue = useCallback(
    (key) => (value) => {
      setFields((previousCompanyFields) => {
        const field = previousCompanyFields[key];
        return { ...previousCompanyFields, [key]: { ...field, value } };
      });
    },
    [setFields]
  );

  return [fields, setFields, updateCompanyFieldValue];
}
